import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    updateMemberEmail,
    updateMemberEmailSuccess,
    updateMemberEmailFail
} from './workflows.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { WorkflowsTableService } from './workflows-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';

@Injectable()
export class WorkflowsRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'workflows';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.moduleTableService.clubs = data.clubs;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'workflows/'+data.id+"/edit";
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        
                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchSingleRecordSuccess({singleData: data.workflow, steps: data.steps});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/workflows");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateMemberEmail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateMemberEmail),
            exhaustMap(({ memberId, email }) => {
                const url = `member/${memberId}/email`;
                return this.crudServerService
                    .updateDataPost(url, { email }) // or .post(...) depending on your service
                    .pipe(
                        map((response: any) => {
                            // your backend might return message
                            this.alertService.triggerAlert(response.message, 'success');
                            return updateMemberEmailSuccess({
                                memberId,
                                email,
                                message: response.message,
                            });
                        }),
                        catchError((error) =>
                            of(error).pipe(
                                tap(() => this.alertService.triggerAlert(error, 'error')),
                                map(() => updateMemberEmailFail({ memberId, error }))
                            )
                        )
                    );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private moduleTableService: WorkflowsTableService,
        private tableService: DatatableService
    ) { }

}